import{shopifyProductToUnlikelyProduct as r}from"../../products/utils/serializers.js";function t(t){return"Product"===t.__typename?r(t):[]}export{t as serializeShopifySearchEntityFromTypename};
//# sourceMappingURL=serializers.js.map
